export const changeFromSchemaAndValue = (schema, value) => {
    return { field: schema.key, value };
};
export const addDataChange = (dataChanges, change) => {
    return Object.assign(Object.assign({}, dataChanges), { [change.field]: change.value });
};
const dataChangeToMultiEditIntentItem = (change, targets) => {
    const targetFields = targets.map((target) => {
        return Object.assign(Object.assign({}, target), { field: change.field });
    });
    return {
        value: change.value,
        targets: targetFields
    };
};
export const changesToMultiEditIntent = (changes, targets) => {
    return Object.entries(changes).map(([key, value]) => {
        return dataChangeToMultiEditIntentItem({ field: key, value }, targets);
    });
};
//# sourceMappingURL=formData.js.map